"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextEditor = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var FroalaEditor_1 = __importDefault(require("../../FroalaEditor/FroalaEditor"));
// Froala Config Constants
var key = "cJC7bC5E2E2G2G2I2yQNDMIJg1IQNSEa1EUAi1XVFQd1EaG3C2A5A4C4D3C2D4G2E2==";
var toolbarButtons = [
    "bold",
    "italic",
    "underline",
    "formatOL",
    "formatUL",
    "insertLink"
];
var editorClass = "sys-froala-editor";
var RichTextEditor = /** @class */ (function (_super) {
    __extends(RichTextEditor, _super);
    function RichTextEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleModelChange = function (value) {
            _this.props.onChange(value);
        };
        _this.onInit = function (editor) {
            editor.$$model = _this.props.value;
        };
        _this.config = {
            key: key,
            toolbarButtons: props.toolbarItems || toolbarButtons,
            editorClass: editorClass,
            quickInsertTags: [""],
            attribution: false,
            charCounterCount: false,
            imagePaste: false,
            events: {
                "paste.beforeCleanup": function (clipboardHtml) {
                    // Create a temporary container for the pasted content
                    var tempContainer = document.createElement("div");
                    tempContainer.innerHTML = clipboardHtml;
                    // Remove all span tags
                    var spans = tempContainer.getElementsByTagName("span");
                    while (spans.length > 0) {
                        var parent_1 = spans[0].parentNode;
                        while (spans[0].firstChild) {
                            parent_1.insertBefore(spans[0].firstChild, spans[0]);
                        }
                        parent_1.removeChild(spans[0]);
                    }
                    // Return the cleaned HTML
                    return tempContainer.innerHTML;
                },
                "froalaEditor.initialized": _this.onInit
            },
            wordPasteModal: true,
            plainPaste: true,
            pasteDeniedAttrs: ["class", "style", "id"],
            wordPasteKeepFormatting: false,
            placeholderText: props.placeholderText || "Type something"
        };
        return _this;
    }
    RichTextEditor.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(FroalaEditor_1.default, { id: this.props.id, tag: "div", config: this.config, model: this.props.value, onModelChange: this.handleModelChange }));
    };
    return RichTextEditor;
}(React.Component));
exports.RichTextEditor = RichTextEditor;
